import { Link } from 'react-router-dom';

import {
  FOOTER_TONE,
  FooterCopyright,
  FooterDot,
  FooterLegalNav,
} from '@/shared/components/layout';
import { FOOTER_LEGAL } from '@/shared/constants/app/footerNavigation.ts';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';

/**
 * 품셈해설 전용 푸터.
 *
 * 사이트 기본 푸터를 안 쓰는 이유는 도움말과 같다 — **길이**. 품을 확인한 자리에
 * 사업자 정보 한 뭉치가 붙으면 정작 필요한 다음 행동이 아래로 밀린다.
 *
 * 다만 다음 행동이 도움말과 다르다. 도움말은 "문서에 답이 없으면 문의"지만,
 * 여기서는 **품셈을 확인한 뒤에 실제로 하려는 일이 적산**이다. 그래서 문의보다
 * XCOST 로 가는 길을 앞에 둔다. 품셈해설이 무료 열람인 이유이기도 하다.
 *
 * 색·링크 목록은 `FOOTER_TONE` / `FooterLegalNav` 로 기본 푸터와 공유한다 —
 * 약관 링크가 한쪽에서만 바뀌는 일이 없어야 한다.
 */
export function PumsemFooter() {
  const { company } = FOOTER_LEGAL;

  return (
    <footer
      className={`${FOOTER_TONE.root} ${FOOTER_TONE.edge} px-5 py-9 sm:px-8`}
    >
      <div className="w-full">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
          <p className="text-[14.5px] font-semibold text-neutral-800 dark:text-white/85">
            확인한 품을 내역서로 옮기려면
          </p>
          <Link
            to={PATHS.PRODUCT_XCOST_PRO}
            className="rounded-lg border border-neutral-300 px-3.5 py-1.5 text-[14px] font-semibold text-brand-600 transition-colors hover:border-brand-300 dark:border-white/15 dark:text-brand-300"
          >
            XCOST 통합내역 →
          </Link>
          <Link
            to={PATHS.SUPPORT_INQUIRIES}
            className={`text-[14px] transition-colors ${FOOTER_TONE.meta} ${FOOTER_TONE.metaLink}`}
          >
            1:1 문의
          </Link>
          <FooterDot />
          <a
            href={`tel:${company.tel.replace(/-/g, '')}`}
            className={`text-[14px] transition-colors ${FOOTER_TONE.meta} ${FOOTER_TONE.metaLink}`}
          >
            {company.tel}
          </a>
        </div>

        {/* 표기 근거: 표준품셈의 저작·관리 주체는 우리가 아니다. */}
        <p className={`mt-5 text-[13.5px] ${FOOTER_TONE.meta}`}>
          본 자료는 한국건설기술연구원이 발행하는 건설공사 표준품셈을 열람용으로
          정리한 것입니다. 적용 판단의 책임은 이용자에게 있으며, 원문과 다를
          경우 발행본이 우선합니다.
        </p>

        <FooterLegalNav className="mt-6" />
        <FooterCopyright className="mt-6" />
      </div>
    </footer>
  );
}
